var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"debug-home line-height-default"},[_c('h1',[_vm._v("デバッグ用ページ")]),_c('div',{staticClass:"debug-home__sandbox"},[_c('a',{on:{"click":function($event){return _vm.sandboxEvent()}}},[_vm._v("簡易テスト用")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }